export const constant = {
	selector: {
		target: 'data-m-change-indicator',
		handler: 'data-m-change-indicator-handler',
	},
}
